import { buildCommonFilters, embedFilter } from '../sharedFilters'

const DATASET_KEY = 'bau_complement_form_answers'

const commonFilters = buildCommonFilters(DATASET_KEY, {
  INSTALLATION: { label: 'Inmueble' },
  SECTOR: {},
  CENTER: {},
  MUNICIPALITY: {},
  STATUS: { column: 'bau_complement_status_catalog.name', label: 'Estatus' },
  REGION: {},
  TENANT: {},
  USER: {},
})

export default {
  key: DATASET_KEY,
  label: 'Complemento BAU',
  timeColumn: 'bau_complement_form_answers.created_at',
  permission: { action: 'read', subject: 'BauComplement' },

  tables: {
    bau_complement_form_answers: ["name","data","created_at","updated_at"],
    bau_complements: ["reference_number","evaluation_date","created_at","updated_at"],
    bau_complement_status_catalog: ["name","created_at","updated_at"],
    users: ["check_alarms","frame_color","id_profile","user","email","password","name","first_name","second_name","config","plate_number","created","updated","active","vpn_access","allow_virtual_button_alarm","allow_visual_notifications","allowed_units_live_video_flows","phone_number","alarm_history_per_hours","alarm_history_per_days","alarm_history_by_records","last_login","video_wall","active_sesion_video_wall","id_country","auth_two_factor_code","auth_two_factor_time","auth_two_factor_type","verify_email_code","verify_sms_code","verify_sms","verify_email","online","enabled_chat","enabled_helpdesk"],
    profiles: ["type","description","created_at","updated_at","forced_layouts","token_lifetime","layouts"],
    units: ["id_router","description","address_1","address_2","exterior_number","suburb","number","postal_code","id_country","id_region","id_sector","active","route","plate_number","vin","driver","provider","owner","company","vehicle","allow_virtual_button_alarm","reaction_patrol","id_alarms_levels","active_digital_output","needs_check","id_municipality","time_zone","data","comments","id_category","id_seproban","rems","sirh","created_at","updated_at"],
    routers: ["name"],
    sectors: ["name"],
    centers: ["name"],
    regions: ["name"],
  },

  views: [
    { value: 'bar', label: 'Barras' },
    { value: 'dona', label: 'Dona' },
    { value: 'ring', label: 'Pastel' },
    { value: 'dataframe', label: 'Lista' },
    { value: 'timeseries', label: 'Tendencia' },
    { value: 'json', label: 'JSON', adminOnly: true },
  ],

  defaults: {
    field: 'units.description',
  },

  csvConfig: {
    withTables: 'bau_complement_form_answers',
    columns: 'bau_complements.reference_number,bau_complement_form_answers.data,bau_complement_form_answers.created_at,bau_complement_status_catalog.name,units.description,sectors.name,centers.name,regions.name',
    exceptColumns: 'profiles.layouts,bau_complement_form_answers.name,bau_complement_form_answers.id_bau_complement,profiles.token_lifetime',
    qualifiedColumns: true,
  },

  viewDefaults: {
    csv: { limit: -1 },
    dataframe: { limit: -1 },
    json: { limit: -1 },
    bar: { stack: 'group' },
  },

  fields: [
    { key: 'bau_complement_form_answers.data', label: 'Formulario - BAU Complemento', processForm: true },
    { key: 'units.description', label: 'Inmueble' },
    { key: 'users.name', label: 'Usuario' },
    { key: 'users.id_profile', label: 'Perfil' },
    { key: 'centers.name', label: 'Centro' },
    { key: 'sectors.name', label: 'Región' },
    { key: 'municipalities.name', label: 'Municipio' },
    { key: 'bau_complement_status_catalog.name', label: 'Estatus' },
    { key: 'bau_complements.reference_number', label: 'Referencia' },
    { key: 'bau_complement_form_answers.created_at', label: 'Fecha de creación', defaultParams: { freq: '1mo' } },
  ],

  filters: [
    ...commonFilters,
    {
      key: 'question',
      label: 'Preguntas del formulario',
      forField: 'Preguntas del formulario',
      filterType: 'process-form',
      optionsConfig: {
        type: 'json-keys',
        dataset: DATASET_KEY,
        column: 'bau_complement_form_answers.data',
        limit: -1,
      },
    },
    //embedFilter(DATASET_KEY, 'bau_complements.reference_number', 'Referencia', 'reference'),
  ],

  dateGrouping: {
    column: 'bau_complement_form_answers.created_at',
    presets: [
      { value: '1d', label: 'Día' },
      { value: '1W', label: 'Semana' },
      { value: '1M', label: 'Mes' },
      { value: '1Y', label: 'Año' },
    ],
  },
}
